import { defineStore } from "pinia";
import { computed, ref } from "vue";
import useMyFetch from "@stores/useMyFetch";
import handleError from "@composables/handleError.js";
import { deepCopy } from "@utils/toolBox";
import { captureEvent } from "@/lib/analytics";

export const useTemplateStore = defineStore("template", () => {
  // State
  const template = ref({});
  const initialTemplate = ref({});
  const isNewTemplateVisible = ref(false);

  // Actions - Network
  const getTemplate = async (templateToken) => {
    try {
      const url = `/templates/${templateToken}`;
      const { response, data } = await useMyFetch(url).json();

      if (response.value.ok) {
        template.value = data.value;
        initialTemplate.value = deepCopy(data.value);
      }
    } catch (err) {
      handleError(err);
    }
  };

  const createTemplate = async () => {
    try {
      const { response, data } = await useMyFetch(`/templates`).post(template.value).json();
      if (response.value.ok) {
        template.value = data.value;
        initialTemplate.value = deepCopy(data.value);

        captureEvent("email_template_created", { template_token: template.value.token });
      }
    } catch (err) {
      handleError(err);
    }
  };

  const updateTemplate = async () => {
    try {
      const { response, data } = await useMyFetch(`/templates/${template.value.token}`).patch(template.value).json();
      if (response.value.ok) {
        template.value = data.value;
        initialTemplate.value = deepCopy(data.value);

        captureEvent("email_template_updated", { template_token: template.value.token });
      }
    } catch (err) {
      handleError(err);
    }
  };

  const handleTemplateSave = async () => {
    if (!template.value?.token) {
      await createTemplate();
    } else {
      await updateTemplate();
    }
  };

  const resetTemplate = () => {
    template.value = {};
    initialTemplate.value = {};
  };

  const hasTemplateChanged = computed(() => JSON.stringify(initialTemplate.value) !== JSON.stringify(template.value));

  return {
    // state
    template,
    initialTemplate,
    isNewTemplateVisible,

    // network actions
    getTemplate,
    createTemplate,
    updateTemplate,

    // local actions
    handleTemplateSave,
    resetTemplate,

    // getters
    hasTemplateChanged,
  };
});
